"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MODES = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _addEventListener = _interopRequireDefault(require("./addEventListener"));
var _canUseDOM = _interopRequireDefault(require("./canUseDOM"));

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var MODES = {
  keyboard: 'keyboard',
  pointer: 'pointer'
};
exports.MODES = MODES;
var InputModeListener = /*#__PURE__*/
function () {
  function InputModeListener() {
    var _this = this;
    (0, _classCallCheck2.default)(this, InputModeListener);
    this._listeners = [];
    this._initialized = false;
    this._mode = MODES.keyboard;
    this.onInitialPointerMove = function (event) {
      // Work around a Safari quirk that fires a mousemove on <html> whenever the
      // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
      if (event.target.nodeName.toLowerCase() === 'html') {
        return;
      }
      _this._mode = MODES.pointer;
      _this._listeners.forEach(function (listener) {
        return listener.remove();
      });
    };
    this.onKeyDown = function () {
      _this._mode = MODES.keyboard;
    };
    this.onPointerDown = function () {
      _this._mode = MODES.pointer;
    };
    this.init = function () {
      if (!_canUseDOM.default || _this._initialized) return;
      (0, _addEventListener.default)(document, 'keydown', _this.onKeyDown, true);
      (0, _addEventListener.default)(document, 'mousedown', _this.onPointerDown, true);
      (0, _addEventListener.default)(document, 'pointerdown', _this.onPointerDown, true);
      (0, _addEventListener.default)(document, 'touchstart', _this.onPointerDown, true);
      _this.addInitialPointerMoveListeners();
      _this._initialized = true;
    };
    this.init();
  }
  (0, _createClass2.default)(InputModeListener, [{
    key: "addInitialPointerMoveListeners",
    value: function addInitialPointerMoveListeners() {
      this._listeners.push((0, _addEventListener.default)(document, 'mousemove', this.onInitialPointerMove, true));
      this._listeners.push((0, _addEventListener.default)(document, 'mousedown', this.onInitialPointerMove, true));
      this._listeners.push((0, _addEventListener.default)(document, 'mouseup', this.onInitialPointerMove, true));
      this._listeners.push((0, _addEventListener.default)(document, 'pointermove', this.onInitialPointerMove, true));
      this._listeners.push((0, _addEventListener.default)(document, 'pointerdown', this.onInitialPointerMove, true));
      this._listeners.push((0, _addEventListener.default)(document, 'pointerup', this.onInitialPointerMove, true));
      this._listeners.push((0, _addEventListener.default)(document, 'touchmove', this.onInitialPointerMove, true));
      this._listeners.push((0, _addEventListener.default)(document, 'touchstart', this.onInitialPointerMove, true));
      this._listeners.push((0, _addEventListener.default)(document, 'touchend', this.onInitialPointerMove, true));
    }
  }, {
    key: "isKeyboardMode",
    value: function isKeyboardMode() {
      this.init();
      return this._mode === MODES.keyboard;
    }
  }, {
    key: "mode",
    get: function get() {
      this.init();
      return this._mode;
    }
  }]);
  return InputModeListener;
}();
var _default = new InputModeListener();
exports.default = _default;